import { render, staticRenderFns } from "./show_invoice.vue?vue&type=template&id=2d607d1e"
import script from "./show_invoice.vue?vue&type=script&lang=js"
export * from "./show_invoice.vue?vue&type=script&lang=js"
import style0 from "./show_invoice.vue?vue&type=style&index=0&id=2d607d1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports